import { doorColours, doorRules } from '@planner/config';
import { sanitizeInput } from '../validation.js';
import { classifyDepthClearance, hasUnevenHeights, isOutOfSquare, validateDoorForCommit, } from './derive.js';
export function doorCartTotals(items, region) {
    const totalCents = items.reduce((total, item) => total + Math.round(item.unitPrice * 100) * item.quantity, 0);
    const subtotalCents = Math.round(totalCents / (1 + region.taxRate));
    return {
        subtotal: subtotalCents / 100,
        tax: (totalCents - subtotalCents) / 100,
        total: totalCents / 100,
        currency: region.currency,
    };
}
export function validateDoorLineDetails(door) {
    const name = sanitizeInput(door.doorName, door.doorName.length);
    if (!name || name !== door.doorName || name.length > doorRules.doorNameMaxLength) {
        return {
            valid: false,
            message: `Door name must be between 1 and ${doorRules.doorNameMaxLength} characters`,
        };
    }
    if (!Number.isSafeInteger(door.quantity) ||
        door.quantity < doorRules.quantity.min ||
        door.quantity > doorRules.quantity.max) {
        return {
            valid: false,
            message: `Quantity must be a whole number from ${doorRules.quantity.min} to ${doorRules.quantity.max}`,
        };
    }
    return { valid: true };
}
export function validateReviewedDoor(door) {
    const details = validateDoorLineDetails(door);
    if (!details.valid) {
        return details;
    }
    const colour = doorColours.find((candidate) => candidate.id === door.colourCode);
    if (!colour || colour.name !== door.snapshot.colourName) {
        return { valid: false, message: 'Choose a valid frame colour' };
    }
    const depth = door.depth === undefined ? undefined : classifyDepthClearance(door.depth);
    if (depth === undefined || depth === 'insufficient') {
        return {
            valid: false,
            message: `Depth clearance must be at least ${doorRules.depthClearance.min} mm`,
        };
    }
    if (depth === 'reduced' && !door.depthClearanceAcknowledged) {
        return { valid: false, message: 'Acknowledge the reduced depth clearance' };
    }
    if (door.measurements.mode === 'diy' &&
        isOutOfSquare(door.measurements) &&
        !door.outOfSquareAcknowledged) {
        return { valid: false, message: 'Acknowledge the uneven opening widths' };
    }
    if (door.measurements.mode === 'diy' &&
        hasUnevenHeights(door.measurements) &&
        !door.heightSpreadAcknowledged) {
        return { valid: false, message: 'Acknowledge the uneven opening heights' };
    }
    return validateDoorForCommit(door);
}
//# sourceMappingURL=review.js.map